var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgK1Euro(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.64 24.22l-2.75 5.63a11.23 11.23 0 00-5.9-2c-3.147 0-5.247 2.06-6.3 6.18h10.93l-1.3 3H35.19v2h9.63l-1.37 3h-7.71c.94 4.4 3.113 6.597 6.52 6.59A11.42 11.42 0 0049 46v6.31a13.689 13.689 0 01-6.78 1.67 11.92 11.92 0 01-8.95-3.43 15.3 15.3 0 01-4-8.51h-3.4l1.37-3H29v-1.37a3.675 3.675 0 010-.67h-3l1.3-3h1.76a15.51 15.51 0 014.46-8.61A12.36 12.36 0 0142.43 22a18 18 0 018.2 2.25",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/K1_Euro.b5b4a56e.svg";
export { SvgK1Euro as ReactComponent };